import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import "./ModalFade.css";
export const FadeIn = (props = { isFullFade: true }) => {
    const fadeId = props.isFullFade ? "fadeInModal" : "fadeInModal_Partial";
    return (_jsx(_Fragment, { children: _jsx("div", { id: fadeId, className: "fadeInModal" }) }));
};
export const FadeOut = (props = { isFullFade: true }) => {
    const fadeId = props.isFullFade ? "fadeOutModal" : "fadeOutModal_Partial";
    return (_jsx(_Fragment, { children: _jsx("div", { id: fadeId, className: "fadeOutModal" }) }));
};
